// Module
var code = "<div class=\"mdl-textfield mdl-js-textfield mdl-textfield--floating-label is-dirty\"> <label class=\"mdl-textfield__label\">{{ label }}</label> <p class=\"faux-mdl-input\"> <slot>{{ value }}</slot> </p> </div> ";
// Exports
export default code;